import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const marketingAgentCalendarAccess: DomainAccessControlConfig = {
  permissions: [Permission.MarketingAgentViewAccess],
}
